import { render, staticRenderFns } from "./PlcChildColumns.vue?vue&type=template&id=8c312fae&scoped=true"
import script from "./PlcChildColumns.vue?vue&type=script&lang=js"
export * from "./PlcChildColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c312fae",
  null
  
)

export default component.exports